import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/caret-square-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM400 426v-340c0-3.3-2.7-6-6-6h-340c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/caret-square-left.js
// module id = 1704
// module chunks = 0